import { StorageRack } from 'app/modules/masters/storage-rack/model/storage-rack.model';

export interface StorageRackState {
  storageRacks: StorageRack[];
  loading: boolean;
  error: any;
  selectedStorageRack: StorageRack | null;
  searchResults: StorageRack[]; // 🔍 Added for search
}

export const initialStorageRackState: StorageRackState = {
  storageRacks: [],
  loading: false,
  error: null,
  selectedStorageRack: null,
    searchResults: [], // 🔍 Added for search


};
